export function replaceWithBr(text) {
    if(text) return text.replace(/\n/g, "<br />");
}